import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'The Game-Day Cheat Sheet',
  subtitle: 'The bench-management roadmap. Line-matching and momentum-shift guides.',
  value: '$80',
  img: 'https://cdn.magicpatterns.com/uploads/hP2xrvzeH3RrHuPNBde22H/5bdfd813-372e-4ef1-8e50-74336d477945-mockup_(1).webp'
}, {
  num: '2',
  title: 'Parent Communication Templates',
  subtitle: 'Ready-to-send messages for updates and logistics handled in minutes.',
  value: '$70',
  img: 'https://cdn.magicpatterns.com/uploads/qdMPVQf3e5pUfhHkHT3KeC/1d93ff7e-dd3f-4c88-88c0-be03b4b71064-mockup_(1).webp'
}, {
  num: '3',
  title: 'Practice Planner (9:16 Layout)',
  subtitle: 'Mobile-first planner to pull up rink-side on your phone with zero stress.',
  value: '$60',
  img: 'https://cdn.magicpatterns.com/uploads/sZ78WEmK1ZgFcXYpTMcYXp/e67d3594-885b-4e58-9a86-ff819e7372a6-mockup_(1).webp'
}, {
  num: '4',
  title: 'Seasonal Progress Tracker',
  subtitle: 'Track every player and team milestone across the full year.',
  value: '$90',
  img: 'https://cdn.magicpatterns.com/uploads/93jeYnFr8CDdiDNJSXoMGD/aeee59a8-a568-4d6b-9250-9205a51fd958-mockup_(1).webp'
}, {
  num: '5',
  title: 'Locker Room Speech Handbook',
  subtitle: 'Pre-game speech frameworks to capture attention and build team grit.',
  value: '$100',
  img: 'https://cdn.magicpatterns.com/uploads/gdBy7cFP94JbK7YLAqWVj7/fbf2df36-fa87-4719-8031-cf1ed519b5fe-mockup_(1).webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Exclusive Strategic Bonuses
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Total Value{' '}
            <span className="line-through text-secondary" data-id="element-15">$400</span> — Included
            for <span className="font-bold text-primary" data-id="element-16">FREE</span> today
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-square bg-bg-main overflow-hidden p-8 sm:p-10" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bonus {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm leading-snug mb-3 flex-1" data-id="element-25">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center gap-2 text-base" data-id="element-26">
                  <span className="text-secondary line-through font-medium" data-id="element-27">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-28">FREE</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}